export default __webpack_public_path__ + "static/media/Headphones.23a11e1f.png";